import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-auth-base',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './auth-base.component.html',
  styleUrl: './auth-base.component.scss'
})
export class AuthBaseComponent {

}
